import { render, staticRenderFns } from "./advocacy.vue?vue&type=template&id=fe35fe9e&scoped=true&"
import script from "./advocacy.vue?vue&type=script&lang=js&"
export * from "./advocacy.vue?vue&type=script&lang=js&"
import style0 from "./advocacy.vue?vue&type=style&index=0&id=fe35fe9e&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe35fe9e",
  null
  
)

export default component.exports